import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Inspections } from 'pages/assetDatabase/assetOverview/Inspections'

function InspectionsRouteComponent() {
  const { siteId } = Route.useSearch()

  if (!siteId) {
    return <Outlet />
  }

  return <Inspections siteId={siteId} />
}

export const Route = createFileRoute('/inspections/')({
  component: InspectionsRouteComponent,
  staticData: {
    title: 'Inspections',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})
